import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Skeleton — pulsierender Platzhalter für noch nicht geladenen Inhalt.
 *
 * Bevorzugt vor Spinnern — die Form der Skeletons sollte ungefähr dem
 * finalen Layout entsprechen, damit es beim Erscheinen des echten Inhalts
 * nicht „springt". Beispiele:
 *
 *   <Skeleton className="h-[2rem] w-[40%]" />     // Headline
 *   <Skeleton className="h-[8rem] w-full" />      // Card-Block
 *   <Skeleton className="h-[1.2rem] w-[12rem]" /> // Inline-Text
 *
 * Ersetzt den Legacy-`Preloader` (Shimmer-Bar) und das ad-hoc „Laden…".
 */
const Skeleton = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    aria-hidden="true"
    className={cn(
      "animate-pulse rounded-[0.6rem] bg-[#e4e4e7]",
      className,
    )}
    {...props}
  />
));
Skeleton.displayName = "Skeleton";

export { Skeleton };
